'use client';

import { useTokenStore } from 'Shared/hooks/useTokenStore';
import jwtDecode from 'jwt-decode';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { CancelWithdrawal } from './CancelWithdrawal';

interface CheckWithdrawalProps {
  children: ReactNode;
}
export const CheckWithdrawal = ({ children }: CheckWithdrawalProps) => {
  const { accessToken } = useTokenStore();
  const [isWithdrew, setIsWithdrew] = useState<boolean>(false);

  useEffect(() => {
    const withdrawal =
      (accessToken && jwtDecode<{ roles: string[] }>(accessToken).roles)?.includes('withdrew') ||
      '';
    if (withdrawal) setIsWithdrew(true);
  }, [accessToken]);

  return isWithdrew ? <CancelWithdrawal /> : children;
};
